import React, { useState, useCallback, useMemo } from "react";
import { useT } from "@transifex/react";
import { RendererProps } from "./index";
import { ContactInfoGrid, FieldLabel, TextInput } from "./renderer-styles";

interface ContactFields {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

const ContactInfoRenderer: React.FC<RendererProps> = ({
  answer,
  onAnswer,
}) => {
  const t = useT();

  const fieldConfig = useMemo(() => [
    { key: "first_name" as keyof ContactFields, label: t("First Name"), type: "text", placeholder: t("First name") },
    { key: "last_name" as keyof ContactFields, label: t("Last Name"), type: "text", placeholder: t("Last name") },
    { key: "email" as keyof ContactFields, label: t("Email"), type: "email", placeholder: t("email@example.com") },
    { key: "phone" as keyof ContactFields, label: t("Phone"), type: "tel", placeholder: t("(555) 555-5555") },
  ], [t]);
  const [fields, setFields] = useState<ContactFields>(() => {
    if (answer?.values?.[0]) {
      return answer.values[0] as ContactFields;
    }
    return { first_name: "", last_name: "", email: "", phone: "" };
  });

  const handleChange = useCallback(
    (key: keyof ContactFields, value: string) => {
      setFields((prev) => {
        const next = { ...prev, [key]: value };
        const isValid = next.first_name.trim().length > 0 && next.last_name.trim().length > 0;
        onAnswer(null, isValid, [next]);
        return next;
      });
    },
    [onAnswer]
  );

  return (
    <ContactInfoGrid>
      {fieldConfig.map(({ key, label, type, placeholder }) => (
        <div key={key}>
          <FieldLabel>{label}</FieldLabel>
          <TextInput
            type={type}
            value={fields[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            placeholder={placeholder}
          />
        </div>
      ))}
    </ContactInfoGrid>
  );
};

export default ContactInfoRenderer;
